import React from 'react';
import styled from '@emotion/styled';

interface Item {
  displayName: string | undefined;
  href?: string;
  active?: boolean;
}

interface BreadcrumbsProps {
  items: Item[];
  separator?: string;
}

const BreadcrumbItem = styled.p`
  font-weight: ${(props: { active: boolean }) =>
    props.active ? '700' : '400'};
  margin-bottom: 0px;
`;

const BreadcrumbLink = styled.a``;

const BreadcrumbContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 40px;
`;

const Separator = styled.a`
  padding-right: 4px;
  padding-left: 4px;
`;

const Breadcrumbs = ({
  items,
  separator = '/',
}: BreadcrumbsProps): React.ReactElement => {
  return (
    <BreadcrumbContainer className="bundle-breadcrumb-container">
      {items.map(({ displayName, href, active }, index) => {
        if (href) {
          return (
            <React.Fragment key={index}>
              <BreadcrumbLink
                className="bundle-breadcrumb-item bundle-breadcrumb-item--link"
                href={href}
              >
                {displayName}
              </BreadcrumbLink>
              {index !== items.length - 1 ? (
                <Separator className="bundle-breadcrumb-separator">
                  {separator}
                </Separator>
              ) : null}
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={index}>
              <BreadcrumbItem
                className="bundle-breadcrumb-item"
                key={index}
                active={active}
              >
                {displayName}
              </BreadcrumbItem>
              {index !== items.length - 1 ? (
                <Separator className="bundle-breadcrumb-separator">
                  {separator}
                </Separator>
              ) : null}
            </React.Fragment>
          );
        }
      })}
    </BreadcrumbContainer>
  );
};

export default Breadcrumbs;
